import { createFileRoute } from '@tanstack/react-router';

import { VariationsPage } from '@/features/cost/variations-page';

export const Route = createFileRoute('/_app/projects/$projectId/cost/variations')({
  component: VariationsRoute,
});

function VariationsRoute() {
  const { projectId } = Route.useParams();
  return <VariationsPage projectId={projectId} />;
}
